import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OrganizationRole } from "~/api/model";
import { useGetOrganization } from "~/api/organizations/organizations";
import { PageLayout } from "~/components/PageLayout";
import { SettingsLayout } from "~/features/settings/components/SettingsLayout";
import { ROUTES, useOrganizationParams } from "~/helpers";

export const SettingsPage = () => {
  const navigate = useNavigate();
  const { organizationId } = useOrganizationParams();
  const { data: organization } = useGetOrganization(organizationId);

  useEffect(() => {
    if (organization?.role === OrganizationRole.GUEST) {
      navigate(ROUTES.ACCESS_DENIED);
    }
  }, [navigate, organization]);

  return (
    <PageLayout>
      <SettingsLayout />
    </PageLayout>
  );
};
